if (!customElements.get('video-audio-toggle')) {
  class VideoAudioToggle extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.video = null;
      this.isMuted = true;
      this.youtubeId = null;
      this.vimeoId = null;
    }

    connectedCallback() {
      if (!window.theme.settings.enable_video_audio_toggle) return;
      const container = this.parentElement;
      if (!container) return;
      this.video = container.querySelector('video');
      if (!this.video) {
        const iframe = container.querySelector('iframe.js-youtube, iframe.js-vimeo');
        if (iframe) {
          if (iframe.classList.contains('js-youtube')) {
            this.youtubeId = iframe.src.match(/\/embed\/([^?]+)/)?.[1];
          } else if (iframe.classList.contains('js-vimeo')) {
            this.vimeoId = iframe.src.match(/\/video\/([^?]+)/)?.[1];
          }
          this.video = iframe;
        }
      }
      if (!this.video) return;
      this.render();
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    render() {
      this.button = document.createElement('button');
      this.button.className = 'video-audio-toggle__button';
      this.button.setAttribute('type', 'button');
      this.button.setAttribute('aria-label', 'Unmute video');
      this.button.innerHTML = this.getIcon('theme-speaker-off');
      this.appendChild(this.button);
    }

    getIcon(name) {
      const strokeWidth = getComputedStyle(document.documentElement).getPropertyValue('--icon-stroke-width').trim() || '1.5';
      const cornerShape = getComputedStyle(document.documentElement).getPropertyValue('--icon-corner-shape').trim() || 'round';
      if (name === 'theme-speaker') {
        return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linejoin="${cornerShape}" data-ignore-fill/>
          <path d="M15.54 8.46C17.5 10.53 17.5 13.47 15.54 15.54" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="${cornerShape}" stroke-linejoin="${cornerShape}" data-ignore-fill/>
          <path d="M19.07 5.93C22.97 9.9 22.97 14.1 19.07 18.07" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="${cornerShape}" stroke-linejoin="${cornerShape}" data-ignore-fill/>
        </svg>`;
      }
      return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linejoin="${cornerShape}" data-ignore-fill/>
        <path d="M22 9L15 16" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="${cornerShape}" stroke-linejoin="${cornerShape}" data-ignore-fill/>
        <path d="M15 9L22 16" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="${cornerShape}" stroke-linejoin="${cornerShape}" data-ignore-fill/>
      </svg>`;
    }

    toggle() {
      if (this.video.tagName === 'VIDEO') {
        this.video.muted = !this.video.muted;
        this.isMuted = this.video.muted;
      } else if (this.video.tagName === 'IFRAME') {
        this.isMuted = !this.isMuted;
        if (this.youtubeId) {
          this.video.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: this.isMuted ? 'mute' : 'unMute',
            args: ''
          }), '*');
        } else if (this.vimeoId) {
          this.video.contentWindow.postMessage(JSON.stringify({
            method: 'setMuted',
            value: this.isMuted
          }), '*');
        }
      }
      this.update();
    }

    update() {
      if (this.isMuted) {
        this.button.innerHTML = this.getIcon('theme-speaker-off');
        this.button.setAttribute('aria-label', 'Unmute video');
      } else {
        this.button.innerHTML = this.getIcon('theme-speaker');
        this.button.setAttribute('aria-label', 'Mute video');
      }
    }
  }

  customElements.define('video-audio-toggle', VideoAudioToggle);
}
